import { GA_MEASUREMENT_ID } from './config';

class AnalyticsService {
  trackPageView(path: string) {
    window.gtag?.('event', 'page_view', {
      page_path: path,
    });
  }

  trackWaitlistJoin(country: string) {
    window.gtag?.('event', 'waitlist_join', {
      country,
    });
  }

  trackQuestionView(questionId: string, category: string) {
    window.gtag?.('event', 'question_view', {
      question_id: questionId,
      category,
    });
  }

  trackQuestionVote(questionId: string) {
    window.gtag?.('event', 'question_vote', {
      question_id: questionId,
    });
  }

  trackCategoryFilter(category: string) {
    window.gtag?.('event', 'category_filter', {
      category,
    });
  }
}

export const analytics = new AnalyticsService();